import { useState,useEffect } from "react";
import Container from "react-bootstrap/Container";
import ImageCard from "./imageCard";
import AppSettings from "../../configs/appSettings";
import "./style.css";
import {DownloadImages} from "../../services/useProductDetail";
import {Image, ImageType} from "../../models/image";

const RelatedProducts = (props: any) => {
  const [relations, setRelations] = useState(props.relations);
    const [images, setImages] = useState(props.productImages);

    return (
        <Container className="image-page-body">
          <Container className="image-page-content-container">
            <div className="image-page-main">
            {relations && relations.map((item:any, index:number) => {
              var imageUrl = AppSettings.ApiBaseUrl + '/api/images/product/thumbnail/'+item.primaryImageId+'.jpg';
              var name = item.name;
              return <ImageCard key={item.sku} imageUrl={imageUrl} name={name} sku={item.sku} />;
            })}
            </div>
          </Container>
        </Container>
      );
}

export default RelatedProducts